import { environment } from "../../environments/environment";
import { AccessControl } from "./model/requests/accessControl";

export class Config {
  public url: string;
  public docUrl: string;
  public body: AccessControl;
  public callbackUrl: string;
  public userName: string;
  public password: string;
  public accessControl: String;
  public accessControlUrl: string;
  public porcessDisbursement: string;
  public login: string;
  public userAuthToken: string;
  public reprocessDisbursement: string;
  public accountLookup: string;
  public clientTransactions: string;
  public paymentReq: string;
  public createMandate: string;
  public createUser: string;
  public getClients: string;
  public getRoles: string;
  public setRole: string;
  public updateUser: string;
  public getBeneficiary: string;
  public getGroupBeneficiary: string;
  public deleteGroupBeneficiary: string;
  public getSingleGroupBeneficiary: string;
  public paymentPage: string;
  public verifyAccount: string;
  public createPayment: string;
  public createClient: string;
  public recoverPassword: string;
  public resetpassword: string;
  public updateAdminClientUser: string;
  public paymentInstrument: string;
  public paymentPages: string;
  public updatePassword;
  public updateBusinessDetails: string;
  public settlement: string;
  public logoUpload: string;
  public loginv2: string;
  public getPaymentDetails: string;
  public getPermissions: string;
  public setAdminRole: string;
  public txnDetails: string;
  public logoBaseUrl: String;
  public dashboardData: string;
  public verifyId: string;
  public verifyIdentity: string;

  public getSecretKey = "/api/pgs/admin/v1/getSecretKey/USERNAME";
  public updateSecretKey = "/api/pgs/admin/v1/updateSecretKey/USERNAME";
  analytics = "/api/pgs/payment/v1/getPaymentMetrics";
  constructor() {
    this.url = environment.url;
    this.accessControlUrl = environment.accessControl;
    this.docUrl = environment.documentService;
    this.body = { duration: "", accessType: "", appName: "", plainText: true };
    this.userName = environment.appUser;
    this.password = environment.appPwd;
    this.callbackUrl = environment.callbackUrl;
    this.logoBaseUrl = this.logoBaseUrl = environment.logoBaseUrl;
    this.accessControl = "/api/access-control/v2/getToken";
    this.porcessDisbursement = "/api/pgs/disburse/v1/process";
    this.login = "/api/pgs/clients/v1/login";
    this.loginv2 = "/api/pgs/admin/v1/login";
    this.userAuthToken = "/api/pgs/clients/v1/get/";
    this.reprocessDisbursement = "/api/pgs/disburse/v1/redo";
    this.accountLookup = "/api/agent-network/common/v1/accountlookup";
    this.clientTransactions = "/api/pgs/clients/v1/get/";
    this.paymentReq = "/api/pgs/payment/v1/makePayment";
    this.createMandate = "/api/pgs/payment/v1/createMandate";
    this.createUser = "/api/pgs/clients/v1/createUsers";
    this.getRoles = "/api/pgs/clients/v1/clientUserRoles";
    this.setRole = "/api/pgs/clients/v1/clientUserRoles";
    this.setAdminRole = "/api/pgs/admin/v1/clientUserRoles";
    this.getClients = "/api/pgs/clients/v1/get/";
    this.updateUser = "/api/pgs/clients/v1/updateUsers";
    this.getBeneficiary = "/api/pgs/clients/v1/get/";
    this.getGroupBeneficiary = "/api/pgs/clients/v1/get/";
    this.deleteGroupBeneficiary = "/api/pgs/clients/v1/deleteCustomerGroup";
    this.getSingleGroupBeneficiary = "/api/pgs/clients/v1/get/";
    this.paymentPage = "/api/pgs/payment/v1/paymentPage";
    this.verifyAccount = "/api/pgs/verification/v1/getAccountLookup";
    this.createPayment = "/api/pgs/payment/v1/createPayment";
    this.createClient = "/api/pgs/admin/v1/create";
    this.recoverPassword = "/api/pgs/admin/v1/forgotPassword";
    this.resetpassword = "/api/pgs/admin/v1/recoverPassword";
    this.updateAdminClientUser = "/api/pgs/admin/v1/updateUsers";
    this.paymentInstrument = "/api/pgs/payment/v1/getPaymentInstruments";
    this.paymentPages = "/api/pgs/payment/v1/get/";
    this.updatePassword = "/api/pgs/clients/v1/updatePassword";
    this.updateBusinessDetails = "/api/pgs/clients/v1/update";
    this.settlement = "/api/pgs/clients/v1/get/";
    this.logoUpload = "/api/document-service/documents/v1/upload";
    this.getPaymentDetails = "/api/pgs/admin/payment/v1/getPaymentDetails/";
    this.getPermissions = "/api/pgs/clients/v1/clientPermission";
    this.txnDetails = "/api/pgs/clients/v1/get/";
    this.dashboardData = "/api/analysis_service/v1/pgs/clients";
    this.verifyId = "/api/pgs/verification/v2/admin/getAccountLookup";
    this.verifyIdentity = "/api/pgs/verification/v2/admin/getAccountLookup";
  }
}
